import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

// the read-only view renders the editable form's own grid, just with disabled rows
export {
  Body,
  CalendarDot,
  ReadOnlyValue,
  ScrollArea,
  Section,
} from './event-form.style';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
`;

// Sits with the title, not in the scroll area: it reads as part of the header.
export const Summary = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `0 ${theme.spacing(3)} ${theme.spacing(3)}`};
  color: ${({ theme }) => theme.palette.text.primary};
`;

// date, time zone and repeat describe one thing, so they sit tighter than the location under them
export const SummaryWhen = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const SummaryLine = styled.span`
  overflow-wrap: anywhere;
`;

export const SummaryLocation = styled.span`
  overflow-wrap: anywhere;
`;

export const SummaryLocationLink = styled.a`
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: underline;
  overflow-wrap: anywhere;
`;

export const RsvpRow = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};

  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(4)}`};
`;

export const RsvpControl = styled.div`
  min-width: 12rem;
`;

export const ErrorText = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  flex-shrink: 0;
  margin: 0;
  padding: ${({ theme }) => `0 ${theme.spacing(4)} ${theme.spacing(3)}`};
  color: ${({ theme }) => theme.palette.error.main};
`;
